(ns renolit-roofing-service.view.service.zone-revision-popup
  (:require [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.shared.domain.types :as dom.types]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.tooltip.generic-popup :as tooltip.generic-popup]
            [renolit-roofing-service.util.google-maps :as google-maps]))

(def ^:const view-context ::general-revision)

(def ^:const popup-id tooltip.generic-popup/default-popup-id)

(def general-zone-revision-schema
  [:map
   [:wp
    [:keyword]]
   [:wp-type
    [:keyword]]
   [:tasks
    [:vector
     {:min 1}
     [:map
      [:task-type
       [:keyword]]
      [:comment
       [:string {:min 1}]]]]]])

(defn normalize-tasks
  [tasks]
  (vec
   (keep (fn [{:keys [task-type comment]}]
           (when task-type
             {:task-type task-type
              :comment comment}))
         (vals tasks))))

(defn form-submit
  [data on-submit]
  (let [general-revision (update data :tasks normalize-tasks)
        encoder (m/encoder general-zone-revision-schema
                           mt/strip-extra-keys-transformer)
        gr (encoder general-revision)]
    (if (form.error/check-errors general-zone-revision-schema gr)
      (rf/dispatch [::layout.info-bar/add-info-bar
                    {:context view-context
                     :type :error
                     :msg-transl-kw :form.error-message/revision}])
      (do
        (rf/dispatch [::form.error/clear-errors :context])
        (rf/dispatch [::close])
        (on-submit gr)))))

(defn choice-display-fn
  [{:keys [label-transl-kw]}]
  (t [label-transl-kw]))

(defn task-fieds
  [state idx]
  (let [{:keys [wp wp-type tasks]} @state
        task-ids (get-in dom.types/wp-hierarchy [wp wp-type])
        choices (dom.types/get-dropdown-values :task-type task-ids)]
    [:<>
     [layout.form/item
      {:context view-context
       :type :advanced-select-with-fixed-choices
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:tasks idx :task-type]
       :attribute-path [:options :tasks idx :task-type]
       :schema [:keyword]
       :choices choices
       :choice-display-fn choice-display-fn
       :label-transl-kw :domain.zone/task
       :placeholder-transl-kw :form.advanced-select/select
       :disabled? (or (not wp)
                      (not wp-type))}]
     [layout.form/item
      {:context view-context
       :type :input
       :state state
       :path [:tasks idx :comment]
       :label-transl-kw :domain.zone/comment
       :placeholder-transl-kw :common/select
       :mandatory? true}]
     (when (> (count tasks) 1)
       [:button.flat-btn.form-btn.form-btn--centered
        {:type :button
         :on-click #(swap! state update :tasks dissoc idx)}
        [layout.icon/icon {:key :delete}]])]))

(defn- task-form
  [state idx]
  (let [{:keys [review-type]} @state]
    (if (= review-type :general)
      [:div.general-zone-revision-popup__task
       [task-fieds state idx]]
      [task-fieds state idx])))

(defn- tasks-section
  [state]
  (let [{:keys [tasks review-type]} @state]
    [:<>
     (doall
      (for [[idx _] tasks]
        ^{:key (str idx)}
        [:<>
         [task-form state idx]
         [:button.flat-btn.form-btn.form-btn--centered
          {:type :button
           :on-click #(swap! state update :tasks dissoc idx)}
          [layout.icon/icon {:key "delete"}]]]))
     (when (= review-type :general)
       [:div
        [:button.flat-btn.form-btn
         {:type :button
          :on-click (fn [_]
                      (swap! state assoc-in [:tasks (random-uuid)] {}))}
         (t [:form.advanced-select/add])]])]))

(defn- zone-tree-nodes
  [zone-tree]
  (mapcat
   (fn [z]
     (cons {:id (:zone/id z) :name (:zone/name z)}
           (map (fn [sz] {:id (:zone/id sz) :name (:zone/name sz)})
                (:zone/subzones z))))
   zone-tree))

(defn- zone-tree-ids
  [zone-tree]
  (map :id (zone-tree-nodes zone-tree)))

(defn- zone-tree-selected
  [zone-tree zones-selected]
  (let [selected? (fn [id] (get zones-selected id))]
    (reduce
     (fn [{:keys [ids items]} {:keys [id name]}]
       (if (selected? id)
         {:ids (conj ids id)
          :items (conj items {:id id :name name})}
         {:ids ids :items items}))
     {:ids [] :items []}
     (zone-tree-nodes zone-tree))))

(defn- context-initial-selected-ids
  [_zone-tree context-zone]
  (let [id (:zone/id context-zone)
        subzones (:zone/subzones context-zone)]
    (if (seq subzones)
      (into #{id} (map :zone/id) subzones)
      #{id})))

(defn- set-zone-group!
  [state zone selected?]
  (let [ids (cons (:zone/id zone) (map :zone/id (:zone/subzones zone)))
        v (boolean selected?)]
    (swap! state
           (fn [s]
             (reduce (fn [s id] (assoc-in s [:options :zones-selected id] v))
                     s
                     ids)))))

(defn- set-all-zones!
  [state zones selected?]
  (let [ids (zone-tree-ids zones)
        v (boolean selected?)]
    (swap! state
           (fn [s]
             (-> s
                 (assoc-in [:options :all-zones-selected] v)
                 (update-in [:options :zones-selected]
                            (fn [m]
                              (reduce (fn [m id] (assoc (or m {}) id v))
                                      (or m {})
                                      ids))))))))

(defn- sync-all-zones-selected!
  [state zones]
  (let [ids (zone-tree-ids zones)]
    (swap! state
           (fn [s]
             (let [m (get-in s [:options :zones-selected] {})
                   all? (every? m ids)]
               (assoc-in s [:options :all-zones-selected] all?))))))

(defn- zone-row
  [state zones zone]
  [:div.zones-dropdown__zone-partition
   [layout.form/item
    {:state state
     :type :checkbox
     :path [:options :zones-selected (:zone/id zone)]
     :schema [:boolean]
     :label (:zone/name zone)
     :on-change {:fn (fn [value]
                       (set-zone-group! state zone value)
                       (sync-all-zones-selected! state zones))}}]

   [:div.zones-dropdown__zone-partition--subzone
    (for [sz (:zone/subzones zone)]
      ^{:key (:zone/id sz)}
      [layout.form/item
       {:state state
        :type :checkbox
        :path [:options :zones-selected (:zone/id sz)]
        :schema [:boolean]
        :label (:zone/name sz)
        :on-change {:fn (fn [_]
                          (sync-all-zones-selected! state zones))}}])]])

(defn my-complex-dropdown
  [{:keys [state zones]}]
  [:div.zones-dropdown
   [layout.form/item
    {:state state
     :type :checkbox
     :path [:options :all-zones-selected]
     :schema [:boolean]
     :label-transl-kw :page.general-revision-dropdpwn/all-zones
     :on-change {:fn (fn [v]
                       (set-all-zones! state zones v))}}]
   [:div.zones-dropdown__zone-partition-container
    (for [z zones]
      ^{:key (:zone/id z)}
      [zone-row state zones z])]])

(defn- initial-state
  [zone-tree context-zone review-type {:keys [wp wp-type tasks]}]
  (let [all-ids (zone-tree-ids zone-tree)
        initial-ids (context-initial-selected-ids zone-tree context-zone)
        zones-selected (zipmap all-ids (map initial-ids all-ids))
        {:keys [ids items]}
        (zone-tree-selected zone-tree zones-selected)]
    {:review-type review-type
     :zone-ids ids
     :tasks (->> (or tasks [{}])
                 (map (fn [task] [(random-uuid) task]))
                 (into {}))
     :wp wp
     :wp-type wp-type}))

(defn wp-fields
  [state]
  (let [{:keys [wp]} @state]
    [:<>
     [layout.form/item
      {:context view-context
       :type :advanced-select-with-fixed-choices
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:wp]
       :attribute-path [:options :wp]
       :schema [:keyword]
       :choices (dom.types/get-dropdown-values :wp (keys dom.types/wp-hierarchy))
       :choice-display-fn choice-display-fn
       :label-transl-kw :domain.zone/wp
       :placeholder-transl-kw :form.advanced-select/select
       :on-change {:fn (fn [v]
                         (if (not= v :visual-inspection)
                           (swap! state assoc :wp-type :nil)
                           (swap! state dissoc :wp-type))
                         (swap! state dissoc :task-type))}}]
     (when (= wp :visual-inspection)
       [layout.form/item
        {:context view-context
         :type :advanced-select-with-fixed-choices
         :search? false
         :multi? false
         :mandatory? true
         :state state
         :path [:wp-type]
         :attribute-path [:options :wp-type]
         :schema [:keyword]
         :choices (dom.types/get-dropdown-values :wp-type
                                                 (keys (get dom.types/wp-hierarchy wp)))
         :choice-display-fn choice-display-fn
         :label-transl-kw :domain.zone/wp-type
         :placeholder-transl-kw :form.advanced-select/select
         :disabled? (not wp)
         :on-change {:fn (fn [_]
                           (swap! state dissoc :task-type))}}])]))

(defn- main*
  [zone-tree {:keys [work-package context-zone review-type on-submit]}]
  (let [state (r/atom (initial-state zone-tree context-zone review-type work-package))]
    (fn []
      [:<>
       [tooltip.generic-popup/generic-popup-header
        {:title-transl-kw (t [:page.zone/general-revision])
         :popup-id popup-id}]
       [:div.general-zone-revision-popup
        (when (= review-type :general)
          [layout.form/item
           {:context view-context
            :type :advanced-select
            :search? false
            :dropdown-component my-complex-dropdown
            :dropdown-props {:zones zone-tree}
            :on-close
            {:fn (fn []
                   (swap! state
                          (fn [s]
                            (let [zones-selected (get-in s [:options :zones-selected] {})
                                  {:keys [ids items]} (zone-tree-selected zone-tree zones-selected)]
                              (-> s
                                  (assoc :zone-ids ids)
                                  (assoc-in [:options :zones] items))))))}
            :multi? true
            :mandatory? true
            :read-only? true
            :state state
            :path [:zone-ids]
            :attribute-path [:options :zones]
            :schema [:keyword]
            :choice-id-kw :id
            :choice-display-name-kw :name
            :label-transl-kw :domain.zone/name
            :placeholder-transl-kw :form.advanced-select/select}])
        (if (= review-type :general)
          [:div.general-zone-revision-popup__wp
           [wp-fields state]]
          [wp-fields state])
        (when (= review-type :general)
          [:hr.general-zone-revision-popup__divider])
        [tasks-section state]]
       [tooltip.generic-popup/generic-popup-footer
        {:popup-id popup-id
         :on-cancel {:evt [::tooltip/destroy-by-id {:id popup-id}]}
         :on-accept {:label-transl-kw :common/close
                     :fn (fn [] (form-submit @state on-submit))}}]])))

(defn- main
  [opts]
  (let [zones (rf/subscribe [::google-maps/zones-tree])]
    [main* @zones opts]))

(rf/reg-event-fx
 ::close
 (fn [_]
   {:fx [[:dispatch [::form.error/clear-errors view-context]]
         [:dispatch [::tooltip/destroy-by-id {:id popup-id}]]]}))

(rf/reg-event-fx
 ::open
 (fn [_ [_ opts]]
   {:fx [[:dispatch [::tooltip/register {:id popup-id
                                         :on-destroy-evt [::close]
                                         :component main
                                         :argv [opts]
                                         :class ["generic-popup-standard"]}]]]}))
